import axios from 'axios';

const instance = axios.create({
    // baseURL : (!process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? process.env.REACT_APP_BASE_URL_DEV : process.env.REACT_APP_BASE_URL_QA),
    baseURL: process.env.REACT_APP_BASE_URL,
    withCredentials: true
});

instance.interceptors.response.use((response) => {
    return response
}, function (error) {
    const originalRequest = error.config;
    if (error) {
        if (error.response) {

            // Redirige después de 3 segundos a la página de login si el token expiró
            if (error.response.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true;
                setTimeout(() => window.location.href = '/login', 3000);
            }
        }
    }
    return Promise.reject(error);
});

export default instance;